<template>
  <MetricTile
    :loading="loading"
    :no-data="!metric || !metric.count"
    icon="fa-solid fa-people-group"
    color="teal"
  >
    <template #title>{{ $t("components.ReturningUsersMetricTile.title") }}</template>
    <template #metric-title>{{ $t("components.ReturningUsersMetricTile.metric_title") }}</template>
    <template #metric>
      {{ metric.count }}
    </template>
    <template #info>{{ $t("components.ReturningUsersMetricTile.info") }}</template>
  </MetricTile>
</template>

<script setup lang="ts">
import MetricTile from "@/components/Metrics/MetricTile.vue";
import {useMetricTile} from "@/composables/useMetricTile";
const { metric, loading } = useMetricTile<
  {
    count: number;
  }>("users-returning-over-time");
</script>
